// src/api/user.js

import service from './axios';

// 登录
export function login(data) {
  return service.post('/login', data);
}

//注册
export function register(data) {
  return service.post('/signUp', data);
}

// 注销
export function delUser(data) {
  return service.post('/delUser', data);
}

//获取指定时间段内的平仓列表
export function getTabledata(data) {
  const token = window.sessionStorage.getItem("token") || "";
 
  return service.get(`/ctorder/list/${token}`, { params: data });
}
// home
export function getHome(data) {
  return service.get('/user/home', data);
}

//获取指定交易者未平仓列表
export function getOpenPositions(startTime, endTime) {
  const token = window.sessionStorage.getItem("token") || "";
  return service.get(`/user/getOpenPositions/${token}`);
}

// 获取用户信息
export function getUserInfo() {
  const token = window.sessionStorage.getItem("token") || "";
  return service.get(`/user/getUserInfo/${token}`);
}

// 更新用户银行卡信息
export function upUserPayInfo(data) {
  const token = window.sessionStorage.getItem("token") || "";
  return service.post(`/user/upUserPayInfo/${token}`, data);
}

//获取用户财务明细
export function getUserFinanceInfo(data) {
  const token = window.sessionStorage.getItem("token") || "";
  return service.post(`/ctbalance/queryAll/${token}`, data);
}

// 更新用户信息
export function updateUserInfo(userId, data) {
  return service.post(`/user/${userId}`, data);
}

// 删除用户
export function deleteUser(userId) {
  return service.delete(`/user/${userId}`);
}

//上传文件
export function uploadFile(data) {
  return service.post(`/api/v1/uploadFile`, data);
}

// 提交出入金信息
export function upUserFinanciallog(data) {
  const token = window.sessionStorage.getItem("token") || "";
  return service.post(`/ctfinanciallog/save/${token}`, data);
}

// 修改出入金信息
export function editUserFinanciallog(data) {
  const token = window.sessionStorage.getItem("token") || "";
  return service.post(`/ctfinanciallog/update/${token}`, data);
}

// 删除出入金信息
export function delUserFinanciallog(data) {
  const token = window.sessionStorage.getItem("token") || "";
  return service.post(`/ctfinanciallog/delete/${token}`, data);
}

//获取未审核的出入金信息
export function getFinanciallog(data) {
  const token = window.sessionStorage.getItem("token") || "";
  return service.get(`/ctfinanciallog/queryAll/${token}`, { params: data });
}
